import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HealthCheckService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  checkHealth = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'GET',
      url: '/api/app/health-check/check-health',
    },
    { apiName: this.apiName,...config });
}